import { appendIf } from '@btime/helpers'
import { assoc, compose, pick } from 'ramda'
import { gql, useMutation } from '@apollo/client'
import { sessionsClient } from '../../../../../../utils/apollo/api'
import { useCloseModal } from '../../../../../../components/modals/ModalsContext'
import moment from 'moment'

const MUTATION = gql`
  mutation UpsertPublicToken($input: PublicTokenInput) {
    upsertPublicToken(input: $input) {
      id
    }
  }
`

const cleanRequest = form => {
  return compose(
    pick(['id', 'name', 'type', 'action', 'amountLeft', 'expireDate', 'conditions', 'payload']),
    item => assoc('amountLeft', parseInt(item.amountLeft), item),
    item => assoc('conditions', item.conditions ? JSON.stringify(item.conditions) : null, item),
    item => assoc('payload', cleanPayload(item.payload), item)
  )(form)
}

const cleanPayload = payload => {
  if (payload == null) return {}
  return compose(
    JSON.stringify,
    pick(['checklistId', 'reasonId', 'reasonName', 'checklistName']),
    assoc('reasonId', payload?.reason?.id),
    assoc('reasonName', payload?.reason?.name),
    assoc('checklistId', payload?.question?.id),
    assoc('checklistName', payload?.question?.name)
  )(payload)
}

const validate = (form, setErrors) => {
  const errors = [
    ...appendIf(!form.action, { path: ['action'], message: 'Campo obrigatório' }),
    ...appendIf(!form.name, { path: ['name'], message: 'Campo obrigatório' }),
    ...appendIf(!form.type, { path: ['type'], message: 'Campo obrigatório' }),
    ...appendIf(!form.payload.reason?.id, { path: ['payload', 'reason'], message: 'Campo obrigatório' }),
    ...appendIf(!form.payload.question?.id, { path: ['payload', 'question'], message: 'Campo obrigatório' })
  ]

  setErrors(errors)
  return errors.length === 0
}

export const useSaveWebhook = () => {
  const closeModal = useCloseModal()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['PublicTokens'], client: sessionsClient })

  const handleRequest = (form, actions) => {
    const input = cleanRequest(form)
    const { setErrors } = actions
    const isValid = validate(form, setErrors)

    if (isValid) {
      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          closeModal()
        }
      })
    }
  }

  return [handleRequest, state]
}
